<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/height-yt2.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>亚太1-4类团意险高端医疗版（非高空）</h2>
					<div>高性价比 | 亚太财产保险有限公司承保 | 全线上操作</div>
					<p>
						① 1-4类工种覆盖广
						<br />
						② 投保简便支持月单
						<br />
						③ 社保用药100%赔付
						<br />
						④ 3人起保，满足客户高医疗保障需求。
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载亚太职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud ref="crud" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药 100%赔付，伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit"></avue-crud>
				</el-card>
				<el-descriptions :column="1" border title="注意事项">
					<el-descriptions-item label="起保人数">
						一份保单须投保
						<span style="color: red">3人以上</span>
					</el-descriptions-item>
				</el-descriptions>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="24">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span>{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="24">
						<h3>保险条款及须知</h3>

						<p style="line-height: 32px">
							1、本保险适用以下保险条款
							<br />
							2、本产品由亚太财产保险有限公司（以下简称“亚太财险”）承保，目前在山东、青岛、广东、河北、河南、北京、浙江、安徽、四川、湖北、内蒙古、辽宁（除大连）、上海、福建、江苏、湖南、天津、陕西、海南、重庆、云南、深圳、宁波设有分支机构。本产品的销售区域为全国。对亚太财险未设立分支机构的地区，可能会存在服务不到位、时效差的问题，但亚太财险会在用户服务和时效上提供竭力保障，任何疑问可拨打亚太财险7*24小时客服服务热线95506。
							<br />
							3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：
							4、保险公司全国统一的客户服务及投诉方式详见如下链接：
							5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							<br />
							7、保费支付：本产品支持使用网上银行、微信、支付宝进行保费支付。
							<br />
							8、本产品为您提供电子保单，根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。为保证您的合法权益，您可拨打亚太财险客服热线95506查询保单信息或验证保单，或登录www.apiins.com进行自助保单验真。
							<br />
							9、本产品自动核保，投保成功后，亚太财险将向您预留的手机发送承保短信/电子保单，请注意查收。此外，您可关注“亚太财险”微信公众号申请电子发票，电子发票是以电子方式存储的收付款凭证，其法律效力、基本用途、基本使用规定等与税务机关监制的纸质发票相同。
							<br />
							10、退保规则：保险责任生效之后退保，保险公司仅退还保单未满期净保费。未满期净保费=保险费（1-20%）×（1-保险责任已经过的天数/保险期间的天数)×100%，经过天数不足一天的按一天计算。
							<br />
							11、本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							<br />
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {optionBenefit, optionPlanTy, optionPremium} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanTy,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '10万',
					plan2: '20万',
					plan3: '30万',
					plan4: '40万',
					plan5: '50万',
					plan6: '60万',
					plan7: '70万',
					plan8: '80万',
					plan9: '90万',
					plan10: '100万',
				},
				{
					insuredItem: '医疗费用',
					plan1: '2万',
					plan2: '4万',
					plan3: '6万',
					plan4: '8万',
					plan5: '10万',
					plan6: '12万',
					plan7: '14万',
					plan8: '16万',
					plan9: '18万',
					plan10: '20万',
				},
				{
					insuredItem: '住院津贴（元/天/人）',
					plan1: '100元限180天',
					plan2: '100元限180天',
					plan3: '100元限180天',
					plan4: '100元限180天',
					plan5: '100元限180天',
					plan6: '100元限180天',
					plan7: '100元限180天',
					plan8: '100元限180天',
					plan9: '100元限180天',
					plan10: '100元限180天',
				},
				{
					insuredItem: '年保费（1-2类）',
					plan1: '115元',
					plan2: '200元',
					plan3: '285元',
					plan4: '370元',
					plan5: '455元',
					plan6: '540元',
					plan7: '625元',
					plan8: '710元',
					plan9: '795元',
					plan10: '880元',
				},
				{
					insuredItem: '年保费（3类）',
					plan1: '115元',
					plan2: '200元',
					plan3: '285元',
					plan4: '370元',
					plan5: '455元',
					plan6: '540元',
					plan7: '/',
					plan8: '/',
					plan9: '/',
					plan10: '/',
				},
				{
					insuredItem: '年保费（4类）',
					plan1: '230元',
					plan2: '400元',
					plan3: '570元',
					plan4: '740元',
					plan5: '910元',
					plan6: '1080元',
					plan7: '/',
					plan8: '/',
					plan9: '/',
					plan10: '/',
				},
				{
					insuredItem: '短期保费',
					plan1: '1个月20%，3个月40%，6个月70%',
				},
				{
					insuredItem: '批增保费',
					plan1: '按日计算比例保费',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '10%',
					level9: '20%',
					level8: '30%',
					level7: '40%',
					level6: '50%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataNotify: [
				{
					levelItem: '起保人数',
					level10: '一份保单须投保3人以上',
				},
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer:
						'本产品由亚太财产保险有限公司（以下简称“亚太财险”）承保，目前在山东、青岛、广东、河北、河南、北京、浙江、安徽、四川、湖北、内蒙古、辽宁（除大连）、上海、福建、江苏、湖南、天津、陕西、海南、重庆、云南、深圳、宁波设有分支机构。本产品的销售区域为全国。对亚太财险未设立分支机构的地区，可能会存在服务不到位、时效差的问题，但亚太财险会在用户服务和时效上提供竭力保障，任何疑问可拨打亚太财险7*24小时客服服务热线95506。',
				},
				{
					question: '被保险人是否有人数、年龄限制？',
					answer:
						'本产品3人及以上起保，被保险人年龄为16-60周岁，16周岁（含）至18周岁（不含）未成年人意外伤害身故保险责任最高保额50万元。',
				},
				{
					question: '意外的定义是什么？',
					answer: '意外伤害：指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。',
				},
				{
					question: '哪些职业不保？',
					answer:
						'本产品拒绝承保职业（即保险人不承担任何赔偿责任）：高处作业人员，以及风险等级超过4类的其他人员，具体以投保时可选职业为准。对于不在职业清单中的职业，保险人不予承保。',
				},
				{
					question: '如果投保，无对应职业可选择，应如何处理？',
					answer: '请咨询平台工作人员，由专业客服为您解答。否则，保险人可能拒保。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→线上支付保费→获取保单。若您投保后需对投保信息进行变更，请咨询平台工作人员。本产品支持使用网上银行、微信、支付宝进行保费支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer:
						'本产品自动核保，投保成功后，亚太财险将向您预留的手机发送承保短信/电子保单，请注意查收。此外，您可关注“亚太财险”微信公众号申请电子发票，电子发票是以电子方式存储的收付款凭证，其法律效力、基本用途、基本使用规定等与税务机关监制的纸质发票相同。',
				},
				{
					question: '保单如何查验真伪？',
					answer:
						'本产品为您提供电子保单，根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。为保证您的合法权益，您可拨打亚太财险客服热线95506查询保单信息或验证保单，或登录www.apiins.com进行自助保单验真。',
				},
				{
					question: '被保险人可以替换吗？',
					answer:
						'本产品不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。',
				},
				{
					question: '出险人员是否可替换出去？',
					answer: '不可以。',
				},
				{
					question: '怎么理赔？',
					answer: '出险后请拨打理赔专线95506报案→收集资料→提交审核→支付赔款、结案。',
				},
				{
					question: '什么是高空作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。',
				},
				{
					question: '被保险人未取得对应的特种作业证书，进行特种作业操作引起的意外事故，保险公司是否承担保险责任？',
					answer: '保险公司不承担保险责任。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。',
				},
				{
					question: '本保单是否有拒保医院？',
					answer:
						'有。北京平谷、怀柔、密云、辽宁铁岭、河北青龙县、廊坊、山东禹城、山东省金乡县、天津静海地区及河南信阳的所有医院发生的住院津贴、医疗费用均不在保险赔偿范围内。',
				},
				{
					question: '退保规则？',
					answer:
						'保险责任生效之后退保，保险公司仅退还保单未满期净保费。未满期净保费=保险费（1-20%）×（1-保险责任已经过的天数/保险期间的天数)×100%，经过天数不足一天的按一天计算。',
				},
			],
		}
	},
	methods: {
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 6 || rowIndex === 7) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
		},
		spanMethodPremium({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			window.open(`https://file.meibaokeji.com/admin_process/profession_category/template_apiins_profession.xlsx?v=83`)
		},
	},
}
</script>

<style scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
